import debug from 'debug';
const log = debug('itp:core:downloads');
export function downloadFile(blob, fileName) {
    const fileURL = URL.createObjectURL(blob);
    log('creating downloadFile BLOB with fileName=`%s`', fileName);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.target = '_blank';
    link.click();
    link.remove();
}
export function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    log('`%s` has been downloaded.', fileName);
}
//# sourceMappingURL=download-file.js.map